<template>
  <el-card body-style="padding:0px 20px" shadow="never">
    <h3 class="common-title mb10">
      客户背景<span v-if="company._id" class="text-btn ml10 mr10" @click="openCompany">查看更多</span>
      <span class="text-btn ml10" @click="openTrainingVideo"
        ><i class="el-icon-video-camera-solid" style="font-size:20px"></i>如何填写项目详情</span
      >
    </h3>
    <div class="card-content">
      <div class="project-detail-content">
        <div class="project-detail-content-title mb10">阿尔法公司认知</div>
        <div class="company-alpha-cognize mb10">
          <span><b>人员受认可度:</b> {{ company.人员受认可度 }}</span>
          <span><b>激励机制:</b> {{ company.激励机制 }}</span> <span><b>固定薪酬:</b> {{ company.固定薪酬 }}</span>
          <span><b>人员稳定性:</b> {{ company.人员稳定性 }}</span>
        </div>
      </div>
      <div class="project-detail-content">
        <div class="project-detail-content-title mb10">一句话介绍：</div>
        <pre>{{ company.一句话简介 }}</pre>
      </div>
      <div class="project-detail-content">
        <div class="project-detail-content-title mb10">公司介绍：</div>
        <pre>{{ company.公司介绍 }}</pre>
      </div>
      <div class="project-detail-content">
        <div class="project-detail-content-title mb10">公司亮点：</div>
        <pre>{{ company.公司亮点 && company.公司亮点.content }}</pre>
      </div>
    </div>
  </el-card>
</template>
<script>
import { defaultProject, defaultCompany } from '../../constant/defaultData'

export default {
  props: {
    project: { type: Object, default: () => window._.cloneDeep(defaultProject) },
    company: { type: Object, default: () => window._.cloneDeep(defaultCompany) },
  },
  data() {
    return {}
  },
  methods: {
    openCompany() {
      window.open(`${window.origin}/#/company/${this.company._id}`)
    },
    openTrainingVideo() {
      app.root.$refs.TrainingVideoDialog.open('项目详情')
    },
  },
}
</script>
<style scoped src="../../css/newProjectDetail.css"></style>
<style scoped>
.company-alpha-cognize {
  display: flex;
}
.company-alpha-cognize span {
  width: 25%;
  text-align: center;
}
</style>
